<template>
  <div id="sd-register">
    <header>
      <div class="close-wrapper">
        <img
          src="../../assets/img/login-img/1-注册-关闭ic@2x.png"
          alt=""
          class="close-icon"
          @click="goBack"
        >
      </div>
      <div class="header-text">
        <p class="register-text">手机号快速登录</p>
      </div>
    </header>
    <!-- 输入框 -->
    <div class="input-wrapper">
      <ul>
        <li class="item-wrapper">
          <img src="../../assets/img/login-img/1-注册-用户ic@2x.png" alt="" class="input-icon">
          <input
            type="number"
            placeholder="请输入手机号"
            pattern="[0-9]*"
            class="input-text"
            v-model="mobile"
          >
        </li>
        <li class="item-wrapper">
          <img src="../../assets/img/login-img/1-注册-验证码ic@2x.png" alt="" class="input-icon">
          <input
            type="number"
            placeholder="请输入验证码"
            pattern="[0-9]*"
            class="input-text"
            v-model="inputSms"
          >
          <p class="get-msg" v-if="!timeFlag>0" @click="sendMsg">获取验证码</p>
          <p class="get-msg" v-if="timeFlag>0">{{timeFlag}}s再次发送</p>
        </li>
      </ul>
      <van-button size="large" type="primary" class="submit-button" @click="onSubmit">登录</van-button>
    </div>
    <!-- end -->
    <div class="other-login">
      <van-divider :style="{ color: '#999', borderColor: '#D7D7D7', padding: '0 19px' }">第三方登录</van-divider>
      <img src="@/assets/img/icon/wechat.png" alt="" class="other-login-icon" @click="wxlogin">
    </div>
  </div>
</template>

<script>
  import api from "@/api/index";
  import { Wechat } from "@/common/Wechat";
  export default {
    data() {
      return {
        mobile: "",
        inputSms: "",
        inputPwd: "",
        timeFlag: 0,
        timeInterVal: null
      };
    },
    watch: {},
    mounted() {
      this.checkOauth();
    },
    methods: {
      checkOauth() {
        if (
          sessionStorage.getItem("isOauth") &&
          sessionStorage.getItem("isOauth") == 1
        ) {
          this.wxlogin();
          sessionStorage.setItem("isOauth", 0);
        } else {
        }
      },
      currentBtnText() {},
      // 发送验证码
      sendMsg() {
        if (this.currentMobile()) {
          let data = {
            mobile: this.mobile,
            action: "others"
          };
          console.log(data);
          let url = `${api.sendSms}?mobile=${data.mobile}&action=${data.action}`;
          this.fetch(url); // 倒计时
        }
      },
      // 验证手机号
      currentMobile() {
        if (this.mobile === "") {
          this.$toast("手机号不能为空");
          return false;
        } else return true;
      },
      // 提交验证
      currentSubmit() {
        if (this.currentMobile()) {
          if (this.inputSms === "") {
            this.$toast("验证码不能为空");
            return false;
          } else {
            return true;
          }
        }
      },
      getOpenId() {
        return new Promise((resolve, reject) => {
          let http = window.location.href;
          if (http.indexOf("openid") > -1) {
            let openid = http.split("openid")[1].split("#")[0];
            if (openid) {
              let id = openid.split("=")[1];
              localStorage.setItem("openid", id);
              console.log("临时解决方案get openid", id);
              return id;
            }
            next();
          } else {
            // let url = `${http.split("/")[1]}/#/SdLogin`;
            // alert(url);
            window.location.href = location.origin + `/wx/tz?url=SdLogin`;
          }
          resolve(http);
        });
      },
      // 微信登录
      wxlogin() {
        this.$http.get(api.loginwx).then(res => {
          if (res.data.code == 0) {
            localStorage.setItem("token", res.data.data.result.token);
            localStorage.setItem("secret", res.data.data.result.secret);
            this.$toast("登录成功");
            if (this.$route.query.redirect) {
              // 配合全局路由导航使用
              console.log("this.$route.query.redirect", this.$route.query);
              this.$router.push({
                path: this.$route.query.redirect,
                query: { from: this.$route.query.loginFrom }
              });
            } else {
              this.$router.push("/SdUserInfo");
            }
          } else if (res.data.code == 50004) {
            if (localStorage.getItem("isMp") == "noIsWxH5" || localStorage.getItem("isMp") == "yes") {
              this.$toast("正在授权...");
              sessionStorage.setItem("isOauth", 1);
              this.getOpenId();
            } else {
              this.$toast({
                message: "此功能需在微信端打开，请您用手机号登录~",
                duration: 1500
              });
            }
          } else if (res.data.code == 50005) {
            this.$toast("尚未注册或绑定微信，请用手机号登录或登录后绑定微信~");
          }
        });
      },
      // 封装请求
      fetch(url) {
        // this.$ObjToFd(data)
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.$toast("发送成功");
            // 发送倒计时
            let flag = 60;
            this.timeInterVal = setInterval(() => {
              this.timeFlag = --flag;
              if (flag === 0) {
                clearInterval(this.timeInterVal);
              }
            }, 1000);
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      goRouter(val) {
        this.$router.push(val);
      },
      // 提交
      onSubmit() {
        if (this.currentSubmit()) {
          let params = {
            mobile: this.mobile,
            vcode: this.inputSms
          };
          let url = `${api.signupLogin}`;
          this.$http.post(url, this.$ObjToFd(params)).then(res => {
            if (res.data.code == 0) {
              localStorage.setItem("token", res.data.data.result.token);
              localStorage.setItem("secret", res.data.data.result.secret);
              this.$http.defaults.headers.common["x-token"] =
                res.data.data.result.token;
              this.$toast("登录成功");
              if (this.$route.query.redirect) {
                // 配合全局路由导航使用
                console.log("this.$route.query.redirect", this.$route.query);
                this.$router.push({
                  path: this.$route.query.redirect,
                  query: { from: this.$route.query.loginFrom }
                });
              } else {
                this.$router.push("/SdUserInfo");
              }
            } else {
              this.$toast(res.data.message);
            }
          });
        }
      },
      goBack() {
        this.$router.go(-1)
        // this.$router.push("/SdSeeDoctor");
        // if (this.$router.back(-1) !== 'undefined') {
        //   this.$router.back(-1)
        // } else {
        //   this.$router.push('/SdSeeDoctor')
        // }
      }
    }
  };
</script>

<style lang="postcss">
  #sd-register {
    height: 100%;
    width: 100%;
    background-color: #fffffd;
    /* background-color: red; */
    position: absolute;
    & header {
      width: 100%;
      padding-top: 63px;
      & .close-wrapper {
        height: 36px;
        margin-bottom: 29px;
        width: 100%;
        & .close-icon {
          position: absolute;
          right: 63px;
          height: 36px;
          width: 36px;
        }
      }
      & .header-text {
        position: absolute;
        width: 100%;
        box-sizing: border-box;
        background-color: #fffffd;
        display: flex;
        padding: 0 38px;
        padding-bottom: 294px;
        padding-top: 30px;
        justify-content: space-between;
        & .register-text {
          font-size: 48px;
          color: #333333;
          font-family: "SourceHanSansCN-Medium";
          font-weight: bold;
        }
      }
    }
    & .input-wrapper {
      background-color: #fffffd;
      position: absolute;
      top: 275px;
      padding-top: 294px;
      padding: 0 38px;
      width: 100%;
      box-sizing: border-box;
      & .item-wrapper {
        position: relative;
        display: flex;
        width: 100%;
        margin-bottom: 45px;
        background-color: #fffffd;
        & .input-icon {
          position: absolute;
          top: 50%;
          margin-top: -14px;
          width: 28px;
          height: 28px;
        }
        & .input-text {
          border: none;
          border-bottom: 1px solid #d7d7d7;
          line-height: normal;
          border-radius: 0;
          width: 100%;
          font-family: "SimHei";
          padding: 20px 0;
          padding-left: 57px;
          font-size: 30px;
          color: #333;
          background-color: #fffffd;
        }
        & .input-text::-webkit-input-placeholder {
          color: #999;
        }
        & .get-msg {
          font-size: 28px;
          color: #ff7e00;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -14px;
        }
      }
      & .submit-button {
        border-radius: 50px;
        font-size: 32px;
        margin-top: 122px;
        box-shadow: 3px 3px 8px 3px rgba(34, 85, 06, 0.2);
        border: 2px solid #2e9817;
        height: 88px;
      }
    }
    & .other-login {
      margin-top: 925px;
      & .other-login-icon {
        display: block;
        margin: 0 auto;
        /* padding-top: 30px; */
        width: 60px;
        height: 60px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduLogin/SdLogin.vue